import React, { JSX } from 'react'

import { Dialog } from '~/components/component-library/Dialog'
import { useAuth } from '~/context/AuthProvider'

export const GlobalModal = (): JSX.Element => {
  const { globalModalState, setGlobalModalState } = useAuth()
  const { isOpen, content, onDismiss } = globalModalState

  // Keep content alive during close animation
  const [contentWithAnimation, setContentWithAnimation] =
    React.useState(content)

  // Update content when opening or when content changes while open
  React.useEffect(() => {
    if (isOpen) setContentWithAnimation(content)
  }, [isOpen, content])

  // NOTE: Radix dialog is forcing pointer events to none on body after closing
  // https://github.com/radix-ui/primitives/issues/1241#issuecomment-2462326355
  React.useEffect(() => {
    if (isOpen) return
    // Cancelled on reopen, or a fast close→reopen wipes the new content
    const timer = setTimeout(() => {
      document.body.style.pointerEvents = ''
      // Clear content after animation completes
      setContentWithAnimation(undefined)
    }, 125) // Slightly longer than the 100ms animation
    return () => clearTimeout(timer)
  }, [isOpen])

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && onDismiss) {
          onDismiss()
        }

        setGlobalModalState({
          isOpen: open,
          content: open ? content : globalModalState.content, // Keep content until animation completes
        })
      }}
    >
      {contentWithAnimation}
    </Dialog>
  )
}
